import { render } from "./AllLessons.vue?vue&type=template&id=a66596b4"
import script from "./AllLessons.vue?vue&type=script&lang=js"
export * from "./AllLessons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__